<template>
  <el-row class="updateResearch">
    <el-col :offset="3" :span="7">
      <el-input v-model="inputWords" :placeholder="$t('upload.请输入段落文字,只允许输入一段文字,段落中及段落后不允许按换行(enter)键')" class="words"
                type="textarea" :rows="7" maxlength="500" show-word-limit/>
    </el-col>
    <el-col :offset="1" :span="4">
      <el-input v-model="inputNotes" :placeholder="$t('upload.请输入图片描述信息,只允许输入一段文字,段落中及段落后不允许按换行(enter)键')" class="notes" type="textarea" :rows="7" maxlength="30" show-word-limit/>
    </el-col>

    <el-col :offset="1" :span="5">
      <el-tooltip :content="$t('upload.仅限一张图片,且图片小于 8MB')" placement="top-start" effect="light">
        <el-upload
                ref="upload"
                :action="uploadURL"
                :file-list="fileList"
                list-type="picture-card"
                accept=".jpg, .jpeg, .png, .gif, .bmp, .JPG, .JPEG, .PBG, .GIF, .BMP"
                :limit="1"
                :auto-upload="false"
                :before-upload="beforeUpload"
                :on-success="afterSuccess"
                :on-error="afterError"
                :headers="headers"
        >
          <template #trigger>
            <!--<el-button type="primary" class="choose">选择</el-button>-->
            <el-icon><Plus /></el-icon>
          </template>
        </el-upload>
      </el-tooltip>
    </el-col>
  </el-row>

  <el-row class="updateResearchEn">
    <el-col :offset="3" :span="7">
      <el-input v-model="inputWordsEn" class="words" type="textarea" :rows="7" maxlength="4000" show-word-limit/>
    </el-col>
    <el-col :offset="1" :span="4">
      <el-input v-model="inputNotesEn" class="notes" type="textarea" :rows="7" maxlength="240" show-word-limit/>
    </el-col>
  </el-row>

</template>

<script>

  import {ref, reactive, getCurrentInstance, onMounted} from 'vue'
  import { ElMessage } from 'element-plus'
  import { mapGetters } from 'vuex'

  import { test } from "@/network/regLogin";

  export default {
    name: "UpdateResearch",
    emits:['uploadSuccess'],
    ...mapGetters(['showToken']),
    props:{
      uploadURL:{
        type: String,
        default: '',
      }
    },
    setup(props, context){
      // common
      let instance = reactive({});
      instance = getCurrentInstance();
      onMounted(() => {
        //instance.ctx.$refs.upload.submit();
      });

      //data
      const inputWords = ref('');
      const inputNotes = ref('');
      const inputWordsEn = ref('');
      const inputNotesEn = ref('');
      //let uploadImg = ref('http://172.20.10.3:8082/research/insert');
      let headers = reactive({
        'token': localStorage.getItem('token'),
      });
      //method



      //data
      let fileList = reactive([]);
      //method
      function submitUpload() {
        instance.proxy.$refs.upload.submit();
        //console.log("子组件提交")
      }
      function beforeUpload(file) {
        const isLt8M = file.size / 1024 / 1024 < 8;     //这里做文件大小限制
        if(!isLt8M) {
          ElMessage({
            message: '上传文件大小不能超过 8MB!',
            type: 'warning'
          });
        }
        return isLt8M
      }
      //上传成功后的钩子
      function afterSuccess() {

        context.emit("uploadSuccess")
        //instance.ctx.$refs.upload.handleRemove();
      }
      //上传失败后的钩子
      function afterError() {
        console.log("error")
      }



      return{ inputWords, inputNotes, headers, inputWordsEn, inputNotesEn,
        fileList, beforeUpload, submitUpload, afterSuccess, afterError

      }
    }
  }
</script>

<style scoped lang="less">
  .updateResearch{
    padding-top: 50px;
  }
  .updateResearchEn{
    padding-top: 30px;
  }

</style>